import { render } from "./EditaNiifNoControlante.vue?vue&type=template&id=6a0453d6"
import script from "./EditaNiifNoControlante.vue?vue&type=script&lang=js"
export * from "./EditaNiifNoControlante.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__